<template>
    <div class="col-md-12 mb-4" v-if="user">
        <div class="container-box">
            <div class="container-box-title">
                {{ translate.account.reviews.reviews }}
                <button class="btn btn-rebrand-grey-outline btn-rebrand-xxs"
                        @click.prevent="reportProfile">{{ translate.account.conversations.report.reportBtn }}</button>
                <button v-if="!isLoggedIn || userHasValidRole"
                        class="btn btn-rebrand-primary btn-rebrand-xxs btn-write-review no-margin"
                        @click="showReviewForm"
                >{{ translate.account.reviews.writeReview }}
                </button>
            </div>

            <div class="container-box-content" id="profile-page-reviews">

                <div class="profile-review-list">
                    <p v-if="allReviews.length < 1">
                        {{ translate.account.reviews.noReviews }}
                    </p>

                    <reviews-single-view-component v-for="review in allReviews"
                                                   class="profile-review-single-view"
                                                   e2e-id="profile-review-single-view-main"
                                                   :reviewProp="review"
                                                   :userProp="user"
                                                   :key="`review-${review.id}-top`"
                                                   @deleted="getAllReviews"
                    >
                    </reviews-single-view-component>

                    <div class="btn btn-rebrand-grey-outline btn-rebrand-xs w-full mt-2"
                         v-if="!viewAll && allReviews.length >= defaultReviewCount">
                        <span @click="getAllReviews" e2e-id="get-all-reviews"
                        >{{ translate.account.viewAll }}</span>
                    </div>

                    <div class="btn btn-rebrand-grey-outline btn-rebrand-xs w-full mt-2" v-if="viewAll && reviews">
                        <span @click="showLessReviews" e2e-id="show-less-reviews"
                        >{{ translate.account.viewLess }}</span>
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>

<script>

import userMixin from "@/components/mixins/userMixin";
import ProfileReviewsSingleViewComponent from "@/components/users/partials/profile_reviews/ProfileReviewsSingleViewComponent";

const data = () => {
    return {
        reviews: null,
        viewAll: false,
        defaultReviewCount: 5,
    }
}

function showReviewForm(e) {
    e.preventDefault();
    e.stopPropagation();

    if (typeof xpa !== 'undefined') {
        xpa(this.currentUser, 'profile', 'review', 'click', this.user.id);
    }

    if (!this.isLoggedIn) {
        return this.showLoginModal();
    }

    $('#modalWriteReview').modal('show');
}

function showLoginModal() {
    $('#modalNotLoggedIn').modal().show();
}

async function getAllReviews() {

    const scrollHeight = document.documentElement.scrollTop;

    const [err, response] = await to(
        api.user.reviews.get(this.user.id)
    );

    this.viewAll = true;

    if (err) {
        return toastr.error(this.translate.home.errorCommon);
    }

    this.reviews = _.get(response, 'data.reviews', null);

    this.$nextTick(() => {
        window.scrollTo(0, scrollHeight);
    });

}

function timeToLocal(timestamp) {
    const serverDate = this.moment.tz(timestamp, 'Europe/Berlin');
    const userTimeZone = this.moment.tz.guess(true);

    let format = 'MMMM DD';

    if (userTimeZone) {
        serverDate.tz(userTimeZone);
    }

    const reviewYear = serverDate.year();
    const currentYear = this.moment().year();

    if (reviewYear < currentYear) {
        format += ' YYYY';
    }

    return serverDate.format(format);
}

function updateReviews(review) {
    this.reviews = _.cloneDeep(this.allReviews);
    this.reviews.unshift(review);

    if (!this.viewAll) {
        this.reviews = _.slice(this.reviews, 0, this.defaultReviewCount);
    }
}

function showLessReviews() {
    this.reviews = _.slice(this.reviews, 0, this.defaultReviewCount);
    this.viewAll = false;
}

function reportProfile() {
    $('#modalReportProfile').modal('show');
}

export default {
    data,
    computed: {
        ...mapState(['currentUser', 'translate']),
        allReviews() {
            let allReviews = this.reviews || _.get(this, 'user.reviews', []);

            if (!this.viewAll && allReviews.length > this.defaultReviewCount) {
                allReviews = _.slice(allReviews, 0, this.defaultReviewCount);
            }

            return allReviews;
        },
        userHasValidRole() {
            const punterOnEscortsProfile = this.isPunter
                && (this.hasRole(this.user, constants.user_role.OFFERING_SERVICES) || this.hasRole(this.user, constants.user_role.VENUE));

            const escortOnPuntersProfile = (this.isEscort || this.isVenue) && this.hasRole(this.user, constants.user_role.SEEKING_SERVICES);

            return punterOnEscortsProfile || escortOnPuntersProfile;

        }
    },
    mixins: [
        userMixin
    ],
    props: ['user'],
    components: {
        'reviews-single-view-component': ProfileReviewsSingleViewComponent,
    },
    methods: {
        showReviewForm,
        showLoginModal,
        getAllReviews,
        timeToLocal,
        updateReviews,
        showLessReviews,
        reportProfile
    }
}
</script>
